<template>
    <v-snackbar
        v-model="snackbar.visible"
        :timeout="snackbar.timeout"
        :multi-line="snackbar.multiline === true"
        :color="snackbar.color ? snackbar.color : `primary`"
        outlined
        bottom
        right
    >  
        {{ snackbar.text }} 
        <template v-slot:action="{ attrs }">
            <v-btn
                :color="snackbar.color ? snackbar.color : `primary`"
                text
                v-bind="attrs"
                @click="closeSnackbar"
            >
                Fechar
            </v-btn>
        </template>
  </v-snackbar>
</template>

<script>
import { mapMutations } from "vuex"

export default {
    computed: {
        snackbar() {
        return this.$store.state.snackbar
        }
    },
    methods: {
        ...mapMutations(["closeSnackbar"])
    }
}
</script>
